import React from 'react';

/*
 * Hand-drawn stroke icons for the few concepts lucide-react has no icon
 * for. Same spec as lucide's own output — 24×24 viewBox, stroke width 2,
 * round caps, currentColor — so the two families sit together without a
 * visible seam.
 */
export const strokeIconProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

/* Horned head in profile, facing right — dragons, mythical beings */
export const DragonIcon: React.FC = () => (
  <svg {...strokeIconProps}>
    <path d="M6 18c-1.2-2.6-1-5.3.6-7.4C8.4 8.3 10.9 7.2 14 7.4" />
    <path d="M14 7.4c2.7.3 4.6 1.9 5.6 4.6l2.4 1.4-2.6.9c-.5 2.6-2.2 4.2-5 4.8" />
    <path d="M12.6 14.3h6.2" />
    <path d="M13.4 7.4 15.6 3l1 4.2" />
    <path d="M15.4 10.8h.01" />
    <path d="M6 18l-2.4 2.2 3.6.2" />
  </svg>
);

/* Helmet with a visor — astronauts */
export const AstronautIcon: React.FC = () => (
  <svg {...strokeIconProps}>
    <circle cx="12" cy="13" r="8" />
    <path d="M8.4 12.2a3.6 3.6 0 0 1 7.2 0v1.6a1.6 1.6 0 0 1-1.6 1.6H10a1.6 1.6 0 0 1-1.6-1.6Z" />
    <path d="M12 5V3" />
    <path d="M20 11.5h.8a1.5 1.5 0 0 1 0 3H20" />
    <path d="M4 11.5h-.8a1.5 1.5 0 0 0 0 3H4" />
  </svg>
);

/* Tapered head with big almond eyes and antennae — aliens */
export const AlienIcon: React.FC = () => (
  <svg {...strokeIconProps}>
    <path d="M12 21c-4.4-2.4-7-6.2-7-10.2A7 7 0 0 1 12 4a7 7 0 0 1 7 6.8c0 4-2.6 7.8-7 10.2Z" />
    <path d="M9.5 10.2c.9.3 1.5 1 1.6 1.9-.9.3-1.9 0-2.5-.7-.6-.7-.7-1.5-.3-1.9.3-.2.7-.2 1.2 0Z" />
    <path d="M14.5 10.2c-.9.3-1.5 1-1.6 1.9.9.3 1.9 0 2.5-.7.6-.7.7-1.5.3-1.9-.3-.2-.7-.2-1.2 0Z" />
    <path d="M8.6 4.6 7.2 1.9" />
    <path d="M15.4 4.6l1.4-2.7" />
  </svg>
);
